export default __webpack_public_path__ + "static/media/CFA_OneLogo_HZ.bc4f5fb5.svg";